<template lang="html">
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">

    <path style="fill:#FFD782;" d="M322.207,512H189.793c-7.313,0-13.241-5.929-13.241-13.241V13.241C176.552,5.929,182.481,0,189.793,0
    	h132.414c7.313,0,13.241,5.929,13.241,13.241v485.517C335.448,506.071,329.519,512,322.207,512z"/>
    <path style="fill:#EFF2FA;" d="M300.138,308.966h-88.276c-4.875,0-8.828-3.953-8.828-8.828V79.448c0-4.875,3.953-8.828,8.828-8.828
    	h88.276c4.875,0,8.828,3.953,8.828,8.828v220.69C308.966,305.013,305.013,308.966,300.138,308.966z"/>
    <g>
    	<path style="fill:#D7DEED;" d="M282.483,150.069h-52.966c-4.875,0-8.828-3.953-8.828-8.828s3.953-8.828,8.828-8.828h52.966
    		c4.875,0,8.828,3.953,8.828,8.828S287.358,150.069,282.483,150.069z"/>
    	<path style="fill:#D7DEED;" d="M282.483,185.379h-52.966c-4.875,0-8.828-3.953-8.828-8.828s3.953-8.828,8.828-8.828h52.966
    		c4.875,0,8.828,3.953,8.828,8.828S287.358,185.379,282.483,185.379z"/>
    	<path style="fill:#D7DEED;" d="M282.483,220.69h-52.966c-4.875,0-8.828-3.953-8.828-8.828c0-4.875,3.953-8.828,8.828-8.828h52.966
    		c4.875,0,8.828,3.953,8.828,8.828C291.31,216.737,287.358,220.69,282.483,220.69z"/>
    	<path style="fill:#D7DEED;" d="M282.483,291.31h-52.966c-4.875,0-8.828-3.953-8.828-8.828s3.953-8.828,8.828-8.828h52.966
    		c4.875,0,8.828,3.953,8.828,8.828S287.358,291.31,282.483,291.31z"/>
    </g>
    <g>
    	<rect x="203.034" y="238.345" style="fill:#C7CFE2;" width="105.931" height="17.655"/>
    	<path style="fill:#C7CFE2;" d="M308.966,105.931H203.034v-35.31c0-4.875,3.953-8.828,8.828-8.828h88.276
    		c4.875,0,8.828,3.953,8.828,8.828V105.931z"/>
    </g>
    <circle style="fill:#464655;" cx="256" cy="388.414" r="22.069"/>
    <path style="fill:#EFF2FA;" d="M256,428.138c-21.906,0-39.724-17.819-39.724-39.724S234.094,348.69,256,348.69
    	s39.724,17.818,39.724,39.724S277.906,428.138,256,428.138z M256,366.345c-12.168,0-22.069,9.901-22.069,22.069
    	s9.901,22.069,22.069,22.069c12.168,0,22.069-9.901,22.069-22.069S268.168,366.345,256,366.345z"/>
    <path style="fill:#C3E678;" d="M481.103,512H348.69c-7.313,0-13.241-5.929-13.241-13.241V13.241C335.448,5.929,341.377,0,348.69,0
    	h132.414c7.313,0,13.241,5.929,13.241,13.241v485.517C494.345,506.071,488.416,512,481.103,512z"/>
    <path style="fill:#EFF2FA;" d="M459.034,308.966h-88.276c-4.875,0-8.828-3.953-8.828-8.828V79.448c0-4.875,3.953-8.828,8.828-8.828
    	h88.276c4.875,0,8.828,3.953,8.828,8.828v220.69C467.862,305.013,463.91,308.966,459.034,308.966z"/>
    <g>
    	<path style="fill:#D7DEED;" d="M441.379,150.069h-52.966c-4.875,0-8.828-3.953-8.828-8.828s3.953-8.828,8.828-8.828h52.966
    		c4.875,0,8.828,3.953,8.828,8.828S446.254,150.069,441.379,150.069z"/>
    	<path style="fill:#D7DEED;" d="M441.379,185.379h-52.966c-4.875,0-8.828-3.953-8.828-8.828s3.953-8.828,8.828-8.828h52.966
    		c4.875,0,8.828,3.953,8.828,8.828S446.254,185.379,441.379,185.379z"/>
    	<path style="fill:#D7DEED;" d="M441.379,220.69h-52.966c-4.875,0-8.828-3.953-8.828-8.828c0-4.875,3.953-8.828,8.828-8.828h52.966
    		c4.875,0,8.828,3.953,8.828,8.828C450.207,216.737,446.254,220.69,441.379,220.69z"/>
    	<path style="fill:#D7DEED;" d="M441.379,291.31h-52.966c-4.875,0-8.828-3.953-8.828-8.828s3.953-8.828,8.828-8.828h52.966
    		c4.875,0,8.828,3.953,8.828,8.828S446.254,291.31,441.379,291.31z"/>
    </g>
    <g>
    	<rect x="361.931" y="238.345" style="fill:#C7CFE2;" width="105.931" height="17.655"/>
    	<path style="fill:#C7CFE2;" d="M467.862,105.931H361.931v-35.31c0-4.875,3.953-8.828,8.828-8.828h88.276
    		c4.875,0,8.828,3.953,8.828,8.828V105.931z"/>
    </g>
    <circle style="fill:#464655;" cx="414.897" cy="388.414" r="22.069"/>
    <path style="fill:#EFF2FA;" d="M414.897,428.138c-21.906,0-39.724-17.819-39.724-39.724s17.818-39.724,39.724-39.724
    	s39.724,17.818,39.724,39.724S436.801,428.138,414.897,428.138z M414.897,366.345c-12.168,0-22.069,9.901-22.069,22.069
    	s9.901,22.069,22.069,22.069s22.069-9.901,22.069-22.069S427.064,366.345,414.897,366.345z"/>
    <path style="fill:#FF6464;" d="M163.31,512H30.897c-7.313,0-13.241-5.929-13.241-13.241V13.241C17.655,5.929,23.584,0,30.897,0
    	H163.31c7.313,0,13.241,5.929,13.241,13.241v485.517C176.552,506.071,170.623,512,163.31,512z"/>
    <path style="fill:#EFF2FA;" d="M141.241,308.966H52.966c-4.875,0-8.828-3.953-8.828-8.828V79.448c0-4.875,3.953-8.828,8.828-8.828
    	h88.276c4.875,0,8.828,3.953,8.828,8.828v220.69C150.069,305.013,146.116,308.966,141.241,308.966z"/>
    <g>
    	<path style="fill:#D7DEED;" d="M123.586,150.069H70.621c-4.875,0-8.828-3.953-8.828-8.828s3.953-8.828,8.828-8.828h52.966
    		c4.875,0,8.828,3.953,8.828,8.828S128.461,150.069,123.586,150.069z"/>
    	<path style="fill:#D7DEED;" d="M123.586,185.379H70.621c-4.875,0-8.828-3.953-8.828-8.828s3.953-8.828,8.828-8.828h52.966
    		c4.875,0,8.828,3.953,8.828,8.828S128.461,185.379,123.586,185.379z"/>
    	<path style="fill:#D7DEED;" d="M123.586,220.69H70.621c-4.875,0-8.828-3.953-8.828-8.828c0-4.875,3.953-8.828,8.828-8.828h52.966
    		c4.875,0,8.828,3.953,8.828,8.828C132.414,216.737,128.461,220.69,123.586,220.69z"/>
    	<path style="fill:#D7DEED;" d="M123.586,291.31H70.621c-4.875,0-8.828-3.953-8.828-8.828s3.953-8.828,8.828-8.828h52.966
    		c4.875,0,8.828,3.953,8.828,8.828S128.461,291.31,123.586,291.31z"/>
    </g>
    <g>
    	<rect x="44.138" y="238.345" style="fill:#C7CFE2;" width="105.931" height="17.655"/>
    	<path style="fill:#C7CFE2;" d="M150.069,105.931H44.138v-35.31c0-4.875,3.953-8.828,8.828-8.828h88.276
    		c4.875,0,8.828,3.953,8.828,8.828V105.931z"/>
    </g>
    <circle style="fill:#464655;" cx="97.103" cy="388.414" r="22.069"/>
    <path style="fill:#EFF2FA;" d="M97.103,428.138c-21.906,0-39.724-17.819-39.724-39.724s17.818-39.724,39.724-39.724
    	s39.724,17.818,39.724,39.724S119.009,428.138,97.103,428.138z M97.103,366.345c-12.168,0-22.069,9.901-22.069,22.069
    	s9.901,22.069,22.069,22.069s22.069-9.901,22.069-22.069S109.271,366.345,97.103,366.345z"/>
  </svg>
</template>

<script>
export default {
  name: 'AnvisaRms'
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/icons/illustration/AnvisaRms.vue